import { render, staticRenderFns } from "./Faecher.vue?vue&type=template&id=233c5150"
import script from "./Faecher.vue?vue&type=script&lang=js"
export * from "./Faecher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports